module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "frame-wrapper",
    style: (_vm.frameSize)
  }, [_c('transition', {
    attrs: {
      "duration": 2000,
      "name": "bounce"
    }
  }, [(_vm.valid) ? _c('div', {
    staticClass: "win"
  }, [_vm._v("Hai vinto un viaggio a..."), _c('br'), _c('br'), _vm._v("  DisneyLand Paris!")]) : _vm._e()]), _vm._v(" "), (_vm.showingOriginal && _vm.image) ? _c('div', {
    staticClass: "original",
    style: ({
      background: ("url(" + _vm.image + ")")
    }),
    on: {
      "click": function($event) {
        _vm.showingOriginal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "frame",
    style: (_vm.frameSize)
  }, _vm._l((_vm.tiles), function(tile) {
    return _c('Tile', {
      key: tile.position,
      ref: "tiles",
      refInFor: true,
      attrs: {
        "tile": tile
      },
      on: {
        "moving": _vm.moveTile
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('a', {
    staticClass: "shuffle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.shuffleTiles($event)
      }
    }
  }, [_vm._v("Reshuffle")]), _vm._v(" "), _c('a', {
    staticClass: "reset",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Reset")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d56b52b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board.vue
// module id = 33
// module chunks = 1